import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

/**
 * Used to tag a string so that we can automatically detect uniqueness across the codebase later.
 */
export function uniqueString(strings: TemplateStringsArray): string {
    return strings.join();
}

/**
 * Used to tag a string so that we can automatically detect uniqueness across the codebase later.
 */
export function uniqueUuid(strings: TemplateStringsArray): Uuid {
    return strings.join() as Uuid;
}
